// @flow
import React from 'react'
import ReactDOM from 'react-dom'
import App from './app'

import './style/modules/_typography.css'
import './style/vendor/_normalize.css'
import './style/vendor/_material.css'

function renderApp() {
  const container = document.getElementById('root')
  if (container) {
    ReactDOM.render(<App />, container)
  } else {
    throw new Error('There is no container available for React app')
  }
}

if (
  process.env.NODE_ENV !== 'production' &&
  process.env.REACT_APP_API_MOCKING === 'true'
) {
  // Mock the backend API with MSW instead of hitting the real API.
  // eslint-disable-next-line global-require
  const { startMockWorker } = require('./mocks/browser')
  startMockWorker().then(renderApp)
} else {
  renderApp()
}
